import { render } from "./ElencoModuliRid.vue?vue&type=template&id=55b54bab&scoped=true"
import script from "./ElencoModuliRid.vue?vue&type=script&lang=js"
export * from "./ElencoModuliRid.vue?vue&type=script&lang=js"

import "./ElencoModuliRid.vue?vue&type=style&index=0&id=55b54bab&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b54bab"]])

export default __exports__